import * as yup from 'yup';
import { changeRuleNameValidation } from '../../validation/changeRuleNameValidation';
import { uniqueArray } from '../../validation/uniqueArray';

const googleAccId = yup
  .string()
  .transform((v) => String(v).replaceAll('-', ''))
  // numbers only
  .matches(/^\d+$/, 'Only numbers are allowed')
  .trim()
  .length(10, 'Account id must be exactly 10 chars');
export const googleAccIdArray = yup
  .array()
  .of(googleAccId)
  .min(1)
  .test('uniqueArray', 'Only unique account ids are allowed', uniqueArray);

const basicValues = yup.object().shape({
  name: yup
    .string()
    .required()
    .min(1)
    .label("Can't be empty")
    .when('$duplicateMode', {
      is: (val: boolean) => val,
      then: (schema) =>
        // @ts-expect-error type correction
        schema.test('uniqueRule', 'You have to change rule name for duplicating', changeRuleNameValidation),
      otherwise: (schema) => schema,
    }),
  project: yup.number().required().label('project'),
  level: yup.string().required().oneOf(['adgroup', 'ad', 'campaign']).label('level'),
  description: yup.string(),
  notificationChannels: yup.array().default([]),
  notificationLevel: yup.string(),
  notificationMessage: yup.object().shape({
    title: yup.string().nullable().default(''),
    body: yup.string().nullable().default(''),
  }),
  adAccountIds: googleAccIdArray,
  ruleStatus: yup.string().required().oneOf(['paused', 'archived', 'active']),
});

export default basicValues;
